export default {
  calendarFetchChunkSize: 15,
  calendarFetchForNotificationsSize: 128,
  allowUntranslatedCrops: false,
  multiLanguage: false,
  wordpressUrl: 'https://www.moestuinweetjes.com/',
  apiLocation: 'wp-json/moestuin-planner',
  firebase: {
    apiKey: 'AIzaSyBMYu47eyEmUtuPqud4YBbMiVD23fiOQV4',
    authDomain: 'moestuinplanner-9fd9c.firebaseapp.com',
    databaseURL: 'https://moestuinplanner-9fd9c.firebaseio.com',
    projectId: 'moestuinplanner-9fd9c',
    storageBucket: 'moestuinplanner-9fd9c.appspot.com',
    messagingSenderId: '764183878630'
  }
}
